export const preloadImage = (url: string): void => {
    const img = new Image();
    img.src = url;
};
